import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';
import Image from '../../basic/image';
import { ProductCategoryKeys } from '../../../common/enums/common';
import { replaceImageHost } from '../../../utils/common';
import { ImageHostName } from '../../../types';
interface BannerMediaProps extends HTMLAttributes<HTMLDivElement> {
  imageUrl?: string;
  layout?: 'left-facing' | 'center-facing' | 'right-facing';
  mediaStyle?: string;
  alt?: string;
  productType?: ProductCategoryKeys
}

const BannerMedia = ({
  imageUrl,
  layout,
  mediaStyle,
  alt,
  productType,
  ...props
}: BannerMediaProps): JSX.Element => {
  const imgSrc = imageUrl ? imageUrl.includes('quality') ? imageUrl : imageUrl+'?format=webp&quality=80' : imageUrl;
  const src = replaceImageHost(imgSrc as string, ImageHostName.CONTENTSTACK, ImageHostName.KPSTORE);
  return (
    <div
      data-testid="bannermedia-test"
      className={clsx(
        'flex w-full',
        {
          'justify-start': layout === 'left-facing',
          'w-full': layout === 'center-facing',
          'justify-end': layout === 'right-facing',
        },
        mediaStyle
      )}
      {...props}
    >
      <Image src={src} alt={"Banner Image"} layout={'responsive'} className={productType == ProductCategoryKeys.CONTACT_LENSES ? 'h-auto' : ''} productType={productType}/>
    </div>
  );
};

export default BannerMedia;
